import React, { useMemo } from 'react';
import DENTModalOverviewButtonsSelection from '../DENTModalOverviewButtonsSelection/DENTModalOverviewButtonsSelection';
import ToggleButtons from '../../../../Components/ToggleButtons/ToggleButtons';
import DENTModalOverviewPathologyFracture from './DENTModalOverviewPathologyFracture';
import { PathologyItem } from '../../Enums/PathologyItem.enum';
import DENTModalOverviewPathologyDecay from './DENTModalOverviewPathologyDecay/DENTModalOverviewPathologyDecay';
import DENTModalOverviewPathologyToothWear, {
	ToothWearType,
} from './DENTModalOverviewPathologyToothWear';
import DENTModalOverviewPathologyDiscoloration from './DENTModalOverviewPathologyDiscoloration';
import DENTModalOverviewPathologyApical from './DENTModalOverviewPathologyApical';
import DENTModalOverviewPathologyDevelopmentDisorder from './DENTModalOverviewPathologyDevelopmentDisorder';
import { useDENTContext } from '../../Services/DENTContext';
import { PathologyOption } from '../../Helpers/pathology/pathologyButtonOptions';
import DENTModalOverviewPathologyRootDecay from './DENTModalOverviewPathologyRootDecay';

interface Props {
	selectedOption?: PathologyOption;
	setSelectedOption: (section: PathologyOption) => void;
	options: PathologyOption[];
	onClose: () => void;
	decayIndex: number;
	setDecayIndex: (index: number) => void;
	onToothWearTypeChange?: (type: ToothWearType | undefined) => void;
}

const DENTModalOverviewPathologyButtons = ({
	selectedOption,
	setSelectedOption,
	options,
	onClose,
	decayIndex,
	setDecayIndex,
	onToothWearTypeChange,
}: Props) => {
	const { activeTooth } = useDENTContext();
	const content: React.ReactNode = useMemo(() => {
		if (!activeTooth) return <></>;

		switch (selectedOption?.value) {
			case PathologyItem.DECAY:
				return (
					<DENTModalOverviewPathologyDecay
						key={activeTooth.number}
						decayIndex={decayIndex}
						setDecayIndex={setDecayIndex}
					/>
				);
			case PathologyItem.ROOT_DECAY:
				return <DENTModalOverviewPathologyRootDecay key={activeTooth.number} />;
			case PathologyItem.FRACTURE:
				return <DENTModalOverviewPathologyFracture key={activeTooth.number} />;
			case PathologyItem.TOOTH_WEAR:
				return (
					<DENTModalOverviewPathologyToothWear
						key={activeTooth.number}
						onTypeChange={onToothWearTypeChange}
					/>
				);
			case PathologyItem.DISCOLORATION:
				return (
					<DENTModalOverviewPathologyDiscoloration key={activeTooth.number} />
				);
			case PathologyItem.APICAL:
				return <DENTModalOverviewPathologyApical key={activeTooth.number} />;
			case PathologyItem.DEVELOPMENT_DISORDER:
				return (
					<DENTModalOverviewPathologyDevelopmentDisorder
						key={activeTooth.number}
					/>
				);
			default:
				return <></>;
		}
	}, [
		selectedOption,
		activeTooth,
		decayIndex,
		setDecayIndex,
		onToothWearTypeChange,
	]);

	return (
		<DENTModalOverviewButtonsSelection
			title={'patientTreatment.meddiDENT.dentalCross.overviewModal.pathology'}
			onClose={onClose}>
			<ToggleButtons<PathologyOption>
				options={options}
				selectedOption={selectedOption}
				onChange={setSelectedOption}
			/>
			{content}
		</DENTModalOverviewButtonsSelection>
	);
};

export default DENTModalOverviewPathologyButtons;
